import lms from '@/http/lms'

const calculatePathDuration = (path) => {
  let sum = 0

  path.pathCourses.forEach((course) => (sum += course.courseDuration))

  return sum
}

export default {
  namespaced: true,
  state: {
    paths: [],
    v4LivesPaths: [],
    pathsFormations: []
  },
  mutations: {
    setPaths(state, paths) {
      state.paths = paths
    },
    setPath(state, path) {
      const persistedPath = state.paths.find((p) => p.pathID === path.pathID)

      Object.assign(persistedPath || {}, path)
    },
    setV4LivesPaths(state, v4LivesPaths) {
      state.v4LivesPaths = v4LivesPaths
    },
    setPathsFormations(state, pathsFormations) {
      state.pathsFormations = pathsFormations
    },
  },
  actions: {
    async getV4Paths({ commit }) {
      try {
        const response = await lms.get('/paths?pathGroup=v4Academy')

        const pathsWithDuration = response.data?.data?.map((path) => {
          return {
            ...path,
            pathDuration: calculatePathDuration(path)
          }
        })

        commit('setPaths', pathsWithDuration)
      } catch (err) {
        console.error(err)
      }
    },
    async getV4LivesPaths({ commit }) {
      try {
        const response = await lms.get('/paths?pathGroup=v4AcademyLives')

        const pathsWithDuration = response.data?.data?.map((path) => {
          return {
            ...path,
            pathDuration: calculatePathDuration(path)
          }
        })

        commit('setV4LivesPaths', pathsWithDuration)
      } catch (err) {
        console.error(err)
      }
    },
    async getPathsFormation({ commit }) {
      try {
        const response = await lms.get('/paths?pathGroup=STAAGEPAIDFORMATION')

        const pathsWithDuration = response.data?.data?.map((path) => {
          return {
            ...path,
            pathDuration: calculatePathDuration(path)
          }
        })

        commit('setPathsFormations', pathsWithDuration)
      } catch (err) {
        console.error(err)
      }
    },
    async getPathByID({ commit }, pathID) {
      try {
        const response = await lms.get(`/paths/${pathID}`)

        if (!response?.data?.data) return null

        const path = response?.data?.data
        const pathWithDuration = {
          ...path,
          pathDuration: calculatePathDuration(path)
        }

        commit('setPath', pathWithDuration)
        return pathWithDuration
      } catch (error) {
        console.error('Error fetching profession:', error)
      }
    }
  },
  getters: {
    getPaths: (state) => state.paths,
    getV4LivesPaths: (state) => state.v4LivesPaths,
    getPathsFormations: (state) => state.pathsFormations,
  }
}
